import { ordersBasketApiConnector } from 'apiConnector/orders-basket';
import { ofType } from 'redux-observable';
import type { Observable } from 'rxjs';
import { EMPTY, merge, of } from 'rxjs';
import { catchError, ignoreElements, mergeMap } from 'rxjs/operators';
import { ordersBasketFormDeletedThunk } from 'state/orders-basket/thunks';
import type { EpicWithThunk } from 'state/state.common';

export interface IOrdersBasketDeleteFormApi {
  deleteForm(negotiationId: string): Observable<void>;
}

export function ordersBasketFormDeletionRequestedEpic(): EpicWithThunk {
  return (actions$, _state$, { oldHttpClient, frontLogger }) =>
    actions$.pipe(
      ofType('ORDERS_BASKET_FORM_DELETION_REQUESTED'),
      mergeMap(action =>
        merge(
          ordersBasketApiConnector(oldHttpClient)
            .deleteForm(action.formId)
            .pipe(
              mergeMap(_ => EMPTY),
              catchError((error: Error) => {
                frontLogger.error(
                  'An error occurred inside ordersBasketFormDeletionRequestedEpic {@FrontError}',
                  error,
                );
                return EMPTY;
              }),
              ignoreElements(),
            ),
          of(ordersBasketFormDeletedThunk(action.formId)),
        ),
      ),
    );
}
